module.exports = __webpack_public_path__ + "img/shipo-icon-arrow-up.c80a5af5.svg";